import {connect} from 'react-redux';
import SupporterProjectBlock from '../../../components/blocks/supporter/SupporterProjectBlock';
import {
    getSupporterProject,
    toggleBooleanValue,
    changeValue,
    editSupporterProject,
    saveSupporterProject, toggleItemValue, setItemValue
} from '../../../actions/supporterProjectAction';

const mapStateToProps = (state, ownProps) => {
    return {
        supporterId: ownProps.supporterId,
        supporterProject: state.supporterProject,
        project: state.project,
        printer: state.printer,
        roles: state.authorization.roles
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSupporterProject(id) {
            dispatch(getSupporterProject(id))
        },
        handleCheckboxInputChange(e) {
            dispatch(toggleBooleanValue(e.target.name))
        },
        handleTextareaInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.value))
        },
        handleSelectInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.value))
        },
        handleChangeValue(name, value) {
            dispatch(changeValue(name, value))
        },
        editSupporterProject() {
            dispatch(editSupporterProject())
        },
        handleFormSubmit(data) {
            dispatch(saveSupporterProject(data))
        },
        toggleItemValue(key) {
            dispatch(toggleItemValue(key))
        },
        setItemValue(key, value) {
            dispatch(setItemValue(key, value))
        }
    }
};

const SupporterProjectBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterProjectBlock);

export default SupporterProjectBlockContainer;
